import {create} from "zustand";

const useVehicleStore = create((set) => ({
    isVehicleCreated: false,
    isVehicleStatusUpdated: false,

    setVehicleCreated: (status) => set({isVehicleCreated: status}),
    setVehicleStatusUpdated: (status) => set({isVehicleStatusUpdated: status}),
}));

export default useVehicleStore